
import {ICategoriaDocumento} from '../interface/ICategoriaDocumento';
import {Documento} from './Documento';

export class CategoriaDocumento implements ICategoriaDocumento {

  id: number;
  nombre: string;
  publicada: boolean;
  fecCreacion?: Date;
  fecModificacion?: Date;
  fichasHijas?: Documento[];

  constructor(catDoc: ICategoriaDocumento) {
    this.id = catDoc.id;
    this.nombre = catDoc.nombre;
    this.publicada = catDoc.publicada;
    this.fecCreacion = catDoc.fecCreacion;
    this.fecModificacion = catDoc.fecModificacion;
  }

  getEstado(): string {
    if (this.publicada) {
      return 'Publicada';
    } else {
      return 'No Publicada';
    }
  }

  getFormData(): FormData {
    const formData = new FormData();
    if (this.nombre) {
      formData.append('nombre', this.nombre);
    }
    if (this.publicada && this.publicada === true) {
      formData.append('publicada', '1');
    } else {
      formData.append('publicada', '0');
    }
    return formData;
  }
}



// WEBPACK FOOTER //
// /app/src/model/class/CategoriaDocumento.ts